import React from 'react';
import { Link } from 'react-router-dom';
import './Classes.css';

const CLASSES = [
  {
    name: 'Iyengar Yoga',
    teacher: 'Tricia',
    accent: 'coral',
    description: 'A precise, focusing on aligning the body with the breath and the soul. The practice often uses props to support and deepen postures. Suitable for all levels. Beginners, intermediate, advanced and women\'s classes available.',
    dropin: '$25',
  },
  {
    name: 'Hatha Yoga',
    teacher: 'Laura',
    accent: 'sage',
    description: 'A grounded, steady practice linking breath and movement. Accessible to all levels with an emphasis on building strength and flexibility.',
    dropin: '$25',
  },
  {
    name: 'Vinyasa Flow',
    teacher: 'Dominique',
    accent: 'coral',
    description: 'Dynamic, flowing sequences that synchronise breath with movement. A more active practice building heat and stamina.',
    dropin: '$25',
  },
  {
    name: 'Therapeutic Yoga',
    teacher: 'Tricia',
    accent: 'sage',
    description: 'Therapeutic Yoga classes is a more curated, personalized approach to addressing individual needs. Students will be asked to fill out an intake form, and feedback forms will be used to tailor future sessions.',
    dropin: '$25',
  },
  {
    name: 'Restorative',
    teacher: 'Laura',
    accent: 'coral',
    description: 'A deeply restful practice using props to fully support the body in long-held, passive postures. Perfect for recovery and stress relief.',
    dropin: '$25',
  },
  {
    name: 'Meditation',
    teacher: 'Laura',
    accent: 'sage',
    description: 'Guided meditation sessions to settle the mind and cultivate presence. Suitable for complete beginners.',
    dropin: '$25',
  },
];

export default function Classes() {
  return (
    <div className="classes-page">
      <section className="classes__hero">
        <p className="section-label">What we offer</p>
        <h1 className="section-heading">Find your practice</h1>
        <p className="classes__hero-sub">
          We offer a range of yoga styles to suit every body and every level —
          from precise alignment work to fluid movement and deep rest.
        </p>
      </section>

      <section className="classes__grid-section">
        <div className="classes__grid">
          {CLASSES.map(cls => (
            <div key={cls.name} className={`class-detail-card class-detail-card--${cls.accent}`}>
              <div className="class-detail-card__header">
                <h3>{cls.name}</h3>
                <span className="class-detail-card__teacher">with {cls.teacher}</span>
              </div>
              <p className="class-detail-card__desc">{cls.description}</p>
              <p className="class-detail-card__price">Drop-in: {cls.dropin}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="classes__schedule">
        <p className="section-label">Book your spot</p>
        <h2 className="section-heading">View the schedule</h2>
        <p className="classes__schedule-sub">
          Browse upcoming classes and book your spot online.
        </p>
        <Link to="/book" className="btn-coral">See full schedule</Link>
      </section>
    </div>
  );
}
